import ButtonContainer from 'core/button-container';
import { CUSTOM_BANNER_FORM_TYPE } from 'components/landing/constants';
import dynamic from 'next/dynamic';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import propTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/ContentBanner.module.scss';
import Text from 'core/text';
import Title from 'core/title';

const CecaES = dynamic(() => import('components/blog/content-banner/horizonal-logo-es'));
const CecaPT = dynamic(() => import('components/blog/content-banner/horizonal-logo-pt'));

const ContentFormBanner = ({ config, bannerType = 'body', culture = 'es-ar' }) => {
    if (config.text === undefined || config.text.title === undefined) {
        return null;
    };

    return (
        <div className={`${styles.container} ${bannerType === 'lateral' ? styles.containerMargin : ''}`}>
            <div className={styles.topMargin} />
            <div className={bannerType === 'body' ? styles.containerBannerBody : styles.containerBannerLateral}>
                {config.config.with_logo && (
                    culture === 'pt-br' ? <CecaPT /> : <CecaES />
                )}
                {config.text.title !== undefined && <Title align titleType="subtitle" content={config.text.title} />}
                <ButtonContainer alignText="center">
                    <FormOrRedirectButton
                        label={config && config.text && config.text.button ? config.text.button.label : ''}
                        formType={CUSTOM_BANNER_FORM_TYPE}
                        refererBannerConfig={config}
                    />
                </ButtonContainer>
                <Spacer />
                {config.text.subtitle !== undefined && <Text align content={config.text.subtitle} />}
            </div>
        </div>
    );
};

ContentFormBanner.propTypes = {
    config: propTypes.shape({
        config: propTypes.shape({
            with_logo: propTypes.bool
        }),
        text: propTypes.shape({
            title: propTypes.string.isRequired,
            subtitle: propTypes.string,
            button: propTypes.shape({
                label: propTypes.string.isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    bannerType: propTypes.string,
    culture: propTypes.string
};

export default ContentFormBanner;
